export default {
  getters: {
    getById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
    getByBuildingId: state => buildingId => {
      return Object.values(state.data).filter(item => {
        return item.building_id == buildingId;
      });
    },
    getAllIdsByBuildingId: state => buildingId => {
      return Object.values(state.data)
        .filter(item => {
          return item.building_id == buildingId;
        })
        .map(item => item.id);
    },
  },
};
